// 配送单
export default [

  //直接装箱
  {
    path: '/directPacking',
    name: 'directPacking',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/directPacking'),
    meta: {
      activeMenu: 'directPacking', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //进行中的配送单
  {
    path: '/underwayPorder',
    name: 'underwayPorder',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/underwayPorder'),
    meta: {
      activeMenu: 'underwayPorder', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //待翻译订单
  {
    path: '/porderTranslate',
    name: 'porderTranslate',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderTranslate'),
    meta: {
      activeMenu: 'porderTranslate', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //贴标配送单列表界面
  {
    path: '/porderLabeling',
    name: 'porderLabeling',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderLabeling'),
    meta: {
      activeMenu: 'porderLabeling', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },

  //配货单待装箱
  {
    path: '/porderToBeBoxed',
    name: 'porderToBeBoxed',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderToBeBoxed'),
    meta: {
      activeMenu: 'porderToBeBoxed', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //配送单待报价
  {
    path: '/porderToBeQuoted',
    name: 'porderToBeQuoted',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderToBeQuoted'),
    meta: {
      activeMenu: 'porderToBeQuoted', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //配送单待支付
  {
    path: '/porderToBePaid',
    name: 'porderToBePaid',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderToBePaid'),
    meta: {
      activeMenu: 'porderToBePaid', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //配送单待出货
  {
    path: '/porderToBeShipped',
    name: 'porderToBeShipped',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderToBeShipped'),
    meta: {
      activeMenu: 'porderToBeShipped', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //配送单已出货
  {
    path: '/porderShipped',
    name: 'porderShipped',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderShipped'),
    meta: {
      activeMenu: 'porderShipped', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  // 配送单待入金
  {
    path: '/porderWaitPaySubmit',
    name: 'porderWaitPaySubmit',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderWaitPaySubmit'),
    meta: {
      activeMenu: 'porderWaitPaySubmit', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  // 配送单入金待确认
  {
    path: '/porderPayWaitConfirm',
    name: 'porderPayWaitConfirm',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderPayWaitConfirm'),
    meta: {
      activeMenu: 'porderPayWaitConfirm', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  配送单重新报价记录
  {
    path: '/porderRollbackRecord',
    name: 'porderRollbackRecord',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderRollbackRecord'),
    meta: {
      activeMenu: 'porderRollbackRecord', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //配送单废弃申请
  {
    path: '/porderDiscardList',
    name: 'porderDiscardList',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/porderDiscardList'),
    meta: {
      activeMenu: 'porderDiscardList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //直接装箱箱子
  {
    path: '/directPackingBox',
    name: 'directPackingBox',
    component: () => import( /* webpackChunkName: "porder" */ '@/views/home/porder/directPackingBox'),
    meta: {
      activeMenu: 'directPackingBox', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },



]
